exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".displayblock[data-v-4a7aeef0]{display:block}@media (max-width:768px){.modal[data-v-4a7aeef0]{width:100%;max-width:100%;height:100vh;margin:0;min-height:100vh}.modal-dialog[data-v-4a7aeef0]{margin:0!important;padding:0!important;height:100%}.modal-content[data-v-4a7aeef0]{height:calc(100vh - 170px)!important;flex:none!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a7aeef0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/modal-empty.vue
// module id = 1136
// module chunks = 0